import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { UpfAssignCurriculumList } from '../upf-assign-gateway.types';
import { UpfAssignGatewayCurriculumCoursesParams } from './upf-assign-gateway-api.types';
import { prepareHeadersBase } from '@services/api/services-api-helpers';

export const upfAssignGatewayApi = createApi({
    reducerPath: 'upfAssignGatewayApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window._env_?.UPF_ASSIGN_GATEWAY_URL || '',
        prepareHeaders: (headers) => prepareHeadersBase(headers)
    }),
    endpoints: (builder) => ({
        getUpfAssignCurriculumCourses: builder.query<UpfAssignCurriculumList, UpfAssignGatewayCurriculumCoursesParams>({
            query: ({ productId, authToken }) => ({
                url: '/publicationCourses',
                params: {
                    productId,
                    authToken
                }
            })
        })
    })
});

export const {
    useGetUpfAssignCurriculumCoursesQuery
} = upfAssignGatewayApi;
